import { ReduxStore } from 'store/types';

function getAllErrorMessage(state: ReduxStore): string {
  return state.category.getAll.config.errorMessage;
}

export default getAllErrorMessage;
